import { Box, Paper, Typography, makeStyles } from '@material-ui/core';
import * as React from 'react';

import { DistrictListing } from '../../../../services/APIService';

interface DistrictConnectionsProps {
  district: DistrictListing;
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    flex: 1,
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column'
  },
  bullet: {
    fontSize: '.4rem',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: '0.35em',
    alignSelf: 'center'
  }
}));

const DistrictConnections: React.FC<DistrictConnectionsProps> = ({
  district
}) => {
  const classes = useStyles();

  if (!(district?.waterConnections || district?.sanitaryConnections)) {
    return null;
  }

  return (
    <Paper className={classes.root}>
      <Box display="flex" flexDirection="column" justifyContent="space-evenly">
        {district?.waterConnections && (
          <Typography variant="body2" gutterBottom>
            {`${district.waterConnections.toLocaleString(undefined, {
              maximumFractionDigits: 0
            })} Water Connections`}
          </Typography>
        )}
        {district?.sanitaryConnections && (
          <Typography variant="body2" gutterBottom>
            {`${district.sanitaryConnections.toLocaleString(undefined, {
              maximumFractionDigits: 0
            })} Sanitary Connections`}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default DistrictConnections;
